// this file added by Bearer Web Developer
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Timer from './timer';
import { useAppState } from '../../../../states/app-state';

interface Props {
    messageText: string
}
const RiderArrivedToOriginMessage: React.FC<Props> = observer(({ messageText }) => {
    const appState = useAppState();
    const order = appState.selectedOrder;
    const timer =
        order?.searchRider?.SearchRiderResponse?.realtime_code === 7 &&
        order?.searchRider?.SearchRiderResponse?.state_description === "Bearer has arrived to the origin address" &&
        order?.searchRider?.SearchRiderResponse?.event_time_accepted_rider_arrived_to_origin_in_ms;
    const [hasTimer, setHastimer] = useState(timer);
    useEffect(() => {
        setHastimer(timer);
    }, [timer, appState.selectedOrderIndex]);
    return (
        <p>
            {messageText}
            {hasTimer && " "}
            {hasTimer && <Timer />}
            {hasTimer && " mins ago."}
        </p>
    )
})
export default RiderArrivedToOriginMessage;